import React from "react";
import { ClearAll } from "@usereactify/search";

import { Button } from "@bared/ui";

export const FilterSectionClearAll = () => {
  return (
    <ClearAll
      render={(props: { clearAll: () => void }) => (
        <Button
          className="text-hint font-medium leading-hint underline"
          variant="plain"
          size="small"
          onClick={props.clearAll}
        >
          Reset Filters
        </Button>
      )}
    />
  );
};
